/**
 * Phase 10.4 — Indian phone-number normalizer for click-to-WhatsApp / tel / copy actions.
 *
 * Rules (per spec):
 *   - Strip spaces, hyphens, brackets, plus signs.
 *   - If phone is 10 digits and starts with 6/7/8/9 → prepend "91".
 *   - If phone already starts with "91" and is 12 digits → use as-is.
 *   - If phone starts with "+91" → convert to "91XXXXXXXXXX".
 *   - Anything else → return null (invalid).
 *
 * Never throws. Never invents digits.
 */

const INDIAN_MOBILE_PREFIXES = /^[6-9]/;

export function normalizeIndianPhone(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;

  // Strip spaces, hyphens, brackets, plus signs (per spec).
  const digits = s.replace(/[\s\-()+.]/g, "");
  if (!/^\d+$/.test(digits)) return null;

  let mobile10 = null;
  if (digits.length === 10 && INDIAN_MOBILE_PREFIXES.test(digits)) {
    mobile10 = digits;
  } else if (digits.length === 12 && digits.startsWith("91") && INDIAN_MOBILE_PREFIXES.test(digits.slice(2))) {
    mobile10 = digits.slice(2);
  } else {
    return null;
  }

  const wa = "91" + mobile10;              // wa.me expects no "+"
  const e164 = "+" + wa;                    // tel: + display
  const display = `+91 ${mobile10.slice(0, 5)} ${mobile10.slice(5)}`;
  return { wa, e164, mobile10, display };
}

export function whatsAppUrl(rawPhone, message) {
  const p = normalizeIndianPhone(rawPhone);
  if (!p) return null;
  if (message) {
    return `https://wa.me/${p.wa}?text=${encodeURIComponent(message)}`;
  }
  return `https://wa.me/${p.wa}`;
}

export function telUrl(rawPhone) {
  const p = normalizeIndianPhone(rawPhone);
  return p ? `tel:${p.e164}` : null;
}
